module.exports = __webpack_public_path__ + "static/media/leader_notes.b69e1baa.pdf";